export default __webpack_public_path__ + "static/media/Venturer's Helm of Pierced Flesh.4f54baf6.jpg";